import { EDGE_BASE } from "./apiBase";

/**
 * 🚀 **index.html 이 먼저 띄워 둔 요청을 받아 쓴다**(책 화면만 · 운영 같은 출처만 · 2026-10-10).
 *
 * 책 표지는 매니페스트·책 목록(둘 다 DB 왕복 약 0.2~0.3초)이 와야 받기 시작하는데, 예전엔 JS 를 다 받은 뒤에야
 * 출발했다(「JS → DB 왕복 → 그림」 줄줄이). index.html 이 head 맨 앞에서 띄워 두면 JS 받는 시간과 겹친다.
 * 응답은 한 번만 읽을 수 있으니 **한 번 쓰고 지운다.** 먼저 띄운 것이 실패했으면 직접 다시 받는다 —
 * 그 때문에 게시본을 놓치면 안 된다. 없으면(다른 화면·개발 환경) 예전처럼 직접 받는다.
 */
export async function fetchEarlyOr(url: string, init: RequestInit): Promise<Response> {
  const early = takeEarly(url);
  // 먼저 띄운 것이 실패했으면 직접 다시 받는다(그쪽은 이미 끝난 실패라 기다림이 더 늘지 않는다)
  return (early ? await early.catch(() => null) : null) ?? fetch(url, init);
}

function takeEarly(url: string): Promise<Response> | undefined {
  if (EDGE_BASE !== "" || typeof window === "undefined") return undefined;
  const bag = (window as unknown as { __gcEarly?: Record<string, Promise<Response> | undefined> }).__gcEarly;
  const p = bag?.[url];
  if (bag && p) delete bag[url];
  return p;
}
